module.exports = __webpack_public_path__ + "static/img/c4.24a52d01.svg";